/* ============
 * Templates Mutations
 * ============
 *
 * The mutations available for the templates module.
 */
import { SET_CURRENT_PAGE } from './types';

export default {
  /**
   * Mutation to  the store with the current page.
   *
   * @param {Object} state      The current state of the store.
   * @param {Array}  currentPage     The current page.
   */
  [SET_CURRENT_PAGE](state, currentPage) {
    state.pagination.currentPage = currentPage;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/templates/mutations.js